export default "https://legacy.eskolare-development.com/images/vertical-color.png";